// extracted by mini-css-extract-plugin
module.exports = {"offer":"offer__2uohM","buttons":"buttons__3c4-b","gray":"gray__10_IB"};